import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";

let user = JSON.parse(localStorage.getItem("currentUser"));
let searchData = {
  Name: '',
  PageNumber: 1,
  PageSize: 5
}
export const getShipManagementList = (item) => {
  let url = `${API.Shiplist}?Name=${item.Name}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "getShipManagementListSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "getShipManagementListFailure",
          error: "ERROR"
        })
      })
  }
}
export const getShipManagementDetail = (id) => {
  let url = `${API.postShip}?shipId=${id}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "getShipManagementDetailSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "getShipManagementDetailFailure",
          error: "ERROR"
        })
      })
  }
}

export const getCertificate = (id) => {
  let url = `${API.Certificates}?shipId=${id}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "getCertificateSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "getCertificateFailure",
          error: "ERROR"
        })
      })
  }
}

export const putShipManagementDetails = (data) => {
  let url = `${API.postShip}`;
  return dispatch => {
    axios.put(url, data, {
      headers: {
        key: user.accessToken,
      }
    })
      .then((response) => {
        console.log("response", response.data)
        dispatch(getShipManagementList(searchData));
        dispatch({
          type: "putShipDetailsSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "putShipDetailsFailure",
          error: "ERROR"
        })
      })
  }
}
export const deleteShipManagementDetails = (data, searchitem) => {
  let url = `${API.postShip}`;
  return dispatch => {
    axios.put(url, data, {
      headers: {
        key: user.accessToken,
      }
    })
      .then((response) => {
        dispatch(getShipManagementList(searchitem));
        dispatch({
          type: "deleteShipDetailsSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "deleteShipDetailsFailure",
          error: "ERROR"
        })
      })
  }
}
export const postShipManagementDetails = (item) => {
  let data = item.shipData;
  let url = `${API.postShip}`;
  return dispatch => {
    axios.post(url, data, {
      headers: {
        key: user.accessToken,
      }
    })
      .then((response) => {
        let inventory = {
          shipId: response.data,
          paintAndCoating: item.paintAndCoating,
          equipmentAndMachinery: item.equipmentAndMachinery,
          structureAndHull: item.structureAndHull,
          store: item.store
        };
        dispatch(postInventoryDetails(inventory));
        dispatch(getShipManagementList(searchData));
        dispatch({
          type: "postShipDetailsSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "postShipDetailsFailure",
          error: "ERROR"
        })
      })
  }
}
export const postInventoryDetails = (data, revise) => {
  let url = `${API.PostInventory}`;
  return dispatch => {
    axios.post(url, data)
      .then((response) => {
        if (response.data && revise) {
          toast.success('Uploaded Successfully', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        dispatch({
          type: "postInventorySuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "postInventoryFailure",
          error: "ERROR"
        })
      })
  }
}

export const postAddInventoryDetails = (data, revise) => {
  let url = `${API.PostAddInventory}`;
  return dispatch => {
    axios.post(url, data)
      .then((response) => {
        if (response.data && revise) {
          toast.success('Uploaded Successfully', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        dispatch({
          type: "postInventorySuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "postInventoryFailure",
          error: "ERROR"
        })
      })
  }
}


export const getPaintCoating = (shipId) => {
  let url = `${API.GetPaintCoating}?shipId=${shipId}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "GetPaintCoatingSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "GetPaintCoatingFailure",
          error: "ERROR"
        })
      })
  }
}

export const getEquipmentMachinery = (shipId) => {
  let url = `${API.GetEquipmentMachinery}?shipId=${shipId}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "GetEquipmentMachinerySuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "GetEquipmentMachineryFailure",
          error: "ERROR"
        })
      })
  }
}

export const getStructureAndHull = (shipId) => {
  let url = `${API.GetStructureHull}?shipId=${shipId}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "GetStructureAndHullSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "GetStructureAndHullFailure",
          error: "ERROR"
        })
      })
  }
}

export const getStores = (shipId) => {
  let url = `${API.GetStore}?shipId=${shipId}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "GetStoreSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "GetStoreFailure",
          error: "ERROR"
        })
      })
  }
}

export const getLRForm = (id, LRFormPDF) => {
  let url = `${API.GetLRForm}?shipId=${id}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        if (response.data === "") {
          dispatch({
            type: "getLRFormPDFSuccess",
            data: "",
          })
        }
        if (LRFormPDF && response.data !== "") {
          dispatch(getLRFormPDF(response.data.shipLrFormId));
        }
        dispatch({
          type: "getLRFormSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "getLRFormFailure",
          error: "ERROR"
        })
      })
  }
}
export const getLRFormUpdate = (id, LRFormPDF) => {
  let url = `${API.GetLRForm}?shipId=${id}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        if (response.data === "") {
          dispatch({
            type: "getLRFormPDFSuccess",
            data: "",
          })
        }
        dispatch({
          type: "getLRFormSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "getLRFormFailure",
          error: "ERROR"
        })
      })
  }
}

export const getLRFormPDF = (id) => {
  let url = `${API.LRFormPDF}?shiplrFormId=${id}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "getLRFormPDFSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "getLRFormPDFFailure",
          error: error
        })
      })
  }
}

export const getInventoyPerson = (id) => {
  let url = `${API.GetPersons}?shipLRFormId=${id}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "getInventoryPersonSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "getInventoryFormFailure",
          error: "ERROR"
        })
      })
  }
}